import { Routes, Route } from 'react-router-dom';
import {
  LayoutDashboard, ClipboardList, FileText, Receipt, Calendar, MessageSquareWarning, BookOpen, Inbox, Banknote, Bell,
} from 'lucide-react';
import PortalLayout, { type NavItem } from '../../components/PortalLayout';

import Dashboard from './Dashboard';
import Assignments from './Assignments';
import Reports from './Reports';
import Expenses from './Expenses';
import Bills from './Bills';
import Complaints from './Complaints';
import Meetings from './Meetings';
import Requests from './Requests';
import Handbook from './Handbook';
import NoticeBoard from '../Admin/NoticeBoard';
import Profile from '../../components/Profile';

const navItems: NavItem[] = [
  { to: '/staff', label: 'Dashboard', icon: <LayoutDashboard className="h-5 w-5" />, end: true },
  { to: '/staff/assignments', label: 'Assignments', icon: <ClipboardList className="h-5 w-5" /> },
  { to: '/staff/reports', label: 'Daily Report', icon: <FileText className="h-5 w-5" /> },
  { to: '/staff/expenses', label: 'Expenses', icon: <Receipt className="h-5 w-5" /> },
  { to: '/staff/bills', label: 'Bills', icon: <Banknote className="h-5 w-5" /> },
  { to: '/staff/complaints', label: 'Complaints', icon: <MessageSquareWarning className="h-5 w-5" /> },
  { to: '/staff/meetings', label: 'Meetings', icon: <Calendar className="h-5 w-5" /> },
  { to: '/staff/requests', label: 'Request', icon: <Inbox className="h-5 w-5" /> },
  { to: '/staff/handbook', label: 'Staff Handbook', icon: <BookOpen className="h-5 w-5" /> },
  { to: '/staff/notices', label: 'Notices', icon: <Bell className="h-5 w-5" /> },
];

export default function StaffPortal() {
  return (
    <PortalLayout title="Staff Portal" navItems={navItems}>
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path="assignments" element={<Assignments />} />
        <Route path="reports" element={<Reports />} />
        <Route path="expenses" element={<Expenses />} />
        <Route path="bills" element={<Bills />} />
        <Route path="complaints" element={<Complaints />} />
        <Route path="meetings" element={<Meetings />} />
        <Route path="requests" element={<Requests />} />
        <Route path="handbook" element={<Handbook />} />
        <Route path="notices" element={<NoticeBoard />} />
        <Route path="profile" element={<Profile />} />
      </Routes>
    </PortalLayout>
  );
}
